import { BaseDataDto } from './base-data.dto';
export class BaseNumberIdDataDto extends BaseDataDto {
    constructor(initializer) {
        super(initializer);
        this.id = initializer.id;
    }
}
